module.exports = __webpack_public_path__ + "img/CheryHolding.d3cd5e27.jpg";